import type { ActivityType } from './profiles';

export type YesNo = 'yes' | 'no';

/** Входные значения формы калькулятора */
export interface CalculatorInput {
	company: string;
	activity: ActivityType;
	name: string;
	phone: string;
	employees: number;
	employeeCost: number;
	orders: number;
	activeMonths: number;
	orderMinutes: number;
	stockMinutes: number;
	reportMinutes: number;
	priceMinutes: number;
	counterpartyMinutes: number;
	communicationMinutes: number;
	documentMinutes: number;
	otcMinutes: number;
	volume: number;
	avgPrice: number;
	storageDays: number;
	storageCost: number;
	creditRate: number;
	hasDeferred: YesNo;
	deferredSales: number;
	deferredDays: number;
	badDebt: number;
	expiredTons: number;
	expiredLoss: number;
	markdownTons: number;
	markdownLoss: number;
	weightDiff: number;
	returns: number;
	hasSite: YesNo;
	siteSupport: number;
	b2bDevelopment: number;
	hasMarketer: YesNo;
	marketerCost: number;
	adBudget: number;
	articles: number;
	articleCost: number;
	aiMinutes: number;
	exhibitions: number;
	exhibitionCost: number;
	warehouses: number;
	users: number;
	personalManager: boolean;
	marketingSupport: boolean;
}

export const STEP_NAMES = ['steps.company', 'steps.time', 'steps.costs', 'steps.features'] as const;

/** Дефолты из исходного HTML-калькулятора */
export const DEFAULT_INPUT: CalculatorInput = {
	company: 'ООО Рыбная компания',
	activity: 'Переработка',
	name: '',
	phone: '',
	employees: 2,
	employeeCost: 160000,
	orders: 100,
	activeMonths: 6,
	orderMinutes: 30,
	stockMinutes: 60,
	reportMinutes: 60,
	priceMinutes: 60,
	counterpartyMinutes: 20,
	communicationMinutes: 180,
	documentMinutes: 90,
	otcMinutes: 30,
	volume: 1200,
	avgPrice: 0,
	storageDays: 60,
	storageCost: 45,
	creditRate: 20,
	hasDeferred: 'yes',
	deferredSales: 50000000,
	deferredDays: 90,
	badDebt: 0,
	expiredTons: 0,
	expiredLoss: 0,
	markdownTons: 0,
	markdownLoss: 0,
	weightDiff: 0,
	returns: 0,
	hasSite: 'yes',
	siteSupport: 0,
	b2bDevelopment: 350000,
	hasMarketer: 'no',
	marketerCost: 0,
	adBudget: 0,
	articles: 4,
	articleCost: 60000,
	aiMinutes: 0,
	exhibitions: 1,
	exhibitionCost: 1500000,
	warehouses: 5,
	users: 3,
	personalManager: false,
	marketingSupport: false,
};
